enum FileStoreType {
	Windows = 1,
	S3 = 2
}

export default FileStoreType;